import React from 'react';
export default function OpenAPIButton(){
  const onClick=()=>{ fetch('/openapi.yaml').then(r=>r.text()).then(txt=>{ const blob=new Blob([txt],{type:'text/yaml'}); const url=URL.createObjectURL(blob); const a=document.createElement('a'); a.href=url; a.download='openapi.yaml'; a.click(); URL.revokeObjectURL(url); }); };
  return <button onClick={onClick}>Scarica OpenAPI YAML</button>;
}
